import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { isCustomObject } from 'automation-ui-references/object-types/objectTypeUtils';
import { DEAL_PIPELINE, DEAL_PIPELINE_STAGE, TICKET_PIPELINE, TICKET_STAGE
// @ts-expect-error untyped module
} from 'reference-resolvers/constants/ReferenceObjectTypes';
import { CONTACT_ID, COMPANY_ID, DEAL_ID, TICKET_ID, QUOTE_ID, CONVERSATION_ID, FEEDBACK_SUBMISSION_ID, GOAL_TARGET_ID, PAYMENT_ID, SUBSCRIPTION_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import GenericEnrollmentTableCell from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/GenericEnrollmentTableCell';
import { jsx as _jsx } from "react/jsx-runtime";
export const contactTableMetadata = {
  numColumns: 2,
  labels: ['automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.name', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.email'],
  avatar: true,
  objectTypeId: CONTACT_ID,
  rowLabelCreators: [objectProperties => {
    return objectProperties.email && objectProperties.email.value;
  }]
};
export const companyTableMetadata = {
  numColumns: 3,
  labels: ['automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.name', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.domain', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.phone'],
  avatar: false,
  objectTypeId: COMPANY_ID,
  rowLabelCreators: [objectProperties => {
    return objectProperties.domain && objectProperties.domain.value;
  }, objectProperties => {
    return objectProperties.phone ? objectProperties.phone.value : '--';
  }]
};
export const dealsTableMetadata = {
  numColumns: 3,
  labels: ['automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.name', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.stage', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.pipeline'],
  avatar: false,
  objectTypeId: DEAL_ID,
  rowLabelCreators: [objectProperties => {
    return objectProperties.dealstage && /*#__PURE__*/_jsx(GenericEnrollmentTableCell, {
      id: objectProperties.dealstage.value,
      objectType: DEAL_PIPELINE_STAGE
    });
  }, objectProperties => {
    return objectProperties.pipeline && /*#__PURE__*/_jsx(GenericEnrollmentTableCell, {
      id: objectProperties.pipeline.value,
      objectType: DEAL_PIPELINE
    });
  }]
};
export const ticketsTableMetadata = {
  numColumns: 3,
  labels: ['automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.name', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.stage', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.pipeline'],
  avatar: false,
  objectTypeId: TICKET_ID,
  rowLabelCreators: [objectProperties => {
    return objectProperties.hs_pipeline_stage && /*#__PURE__*/_jsx(GenericEnrollmentTableCell, {
      id: objectProperties.hs_pipeline_stage.value,
      objectType: TICKET_STAGE
    });
  }, objectProperties => {
    return objectProperties.hs_pipeline && /*#__PURE__*/_jsx(GenericEnrollmentTableCell, {
      id: objectProperties.hs_pipeline.value,
      objectType: TICKET_PIPELINE
    });
  }]
};
export const quotesTableMetadata = {
  numColumns: 2,
  labels: ['automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.title', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.quote'],
  avatar: false,
  objectTypeId: QUOTE_ID,
  rowLabelCreators: [objectProperties => {
    return objectProperties.hs_status && `${objectProperties.hs_status.value.charAt(0)}${objectProperties.hs_status.value.slice(1).toLowerCase()}`;
  }]
};
const conversationStatusOptions = {
  CONVERSATION_STATUS_OPEN: 'Open',
  CONVERSATION_STATUS_CLOSED: 'Closed'
};
export const conversationTableMetadata = {
  numColumns: 3,
  labels: ['automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.conversation', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.createDate', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.conversationStatus'],
  avatar: false,
  objectTypeId: CONVERSATION_ID,
  rowLabelCreators: [objectProperties => {
    return objectProperties.hs_started_at && /*#__PURE__*/_jsx(FormattedDateTime, {
      value: parseInt(objectProperties.hs_started_at.value, 10),
      format: "lll"
    });
  }, objectProperties => {
    return objectProperties.hs_conversation_status && conversationStatusOptions[objectProperties.hs_conversation_status.value];
  }]
};
const feedbackSurveyTypeOptions = {
  CUSTOM: 'Custom Survey',
  NPS: 'Customer Loyalty Survey (NPS)',
  CSAT: 'Customer Satisfaction Survey (CSAT)',
  CES: 'Customer Support Survey (CES)',
  KNOWLEDGE: 'Knowledge article survey'
};
export const feedbackTableMetadata = {
  numColumns: 2,
  labels: ['automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.feedback', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.surveyType'],
  avatar: false,
  objectTypeId: FEEDBACK_SUBMISSION_ID,
  rowLabelCreators: [objectProperties => {
    return objectProperties.hs_survey_type && feedbackSurveyTypeOptions[objectProperties.hs_survey_type.value];
  }]
};
export const goalsTableMetadata = {
  numColumns: 1,
  labels: ['automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.goals'],
  avatar: false,
  objectTypeId: GOAL_TARGET_ID,
  rowLabelCreators: []
};
export const paymentsTableMetadata = {
  numColumns: 3,
  labels: ['automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.paymentAmount', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.paymentDate', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.status'],
  avatar: false,
  objectTypeId: PAYMENT_ID,
  rowLabelCreators: [objectProperties => {
    return objectProperties.hs_initiated_date && /*#__PURE__*/_jsx(FormattedDateTime, {
      value: parseInt(objectProperties.hs_initiated_date.value, 10),
      format: "lll"
    });
  }, objectProperties => {
    return objectProperties.hs_latest_status && `${objectProperties.hs_latest_status.value.charAt(0).toUpperCase()}${objectProperties.hs_latest_status.value.slice(1)}`;
  }]
};
export const subscriptionsTableMetadata = {
  numColumns: 3,
  labels: ['automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.name', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.status', 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.table.startDate'],
  avatar: false,
  objectTypeId: SUBSCRIPTION_ID,
  rowLabelCreators: [objectProperties => {
    return objectProperties.hs_status && `${objectProperties.hs_status.value.charAt(0).toUpperCase()}${objectProperties.hs_status.value.slice(1)}`;
  }, objectProperties => {
    return objectProperties.hs_recurring_billing_start_date && /*#__PURE__*/_jsx(FormattedDateTime, {
      value: parseInt(objectProperties.hs_recurring_billing_start_date.value, 10),
      format: "lll"
    });
  }]
};
export const TABLE_METADATA_BY_OBJECT = {
  [CONTACT_ID]: contactTableMetadata,
  [COMPANY_ID]: companyTableMetadata,
  [DEAL_ID]: dealsTableMetadata,
  [TICKET_ID]: ticketsTableMetadata,
  [QUOTE_ID]: quotesTableMetadata,
  [CONVERSATION_ID]: conversationTableMetadata,
  [FEEDBACK_SUBMISSION_ID]: feedbackTableMetadata,
  [GOAL_TARGET_ID]: goalsTableMetadata,
  [PAYMENT_ID]: paymentsTableMetadata,
  [SUBSCRIPTION_ID]: subscriptionsTableMetadata
};
export const hasRowConfiguration = objectTypeId => {
  return !!TABLE_METADATA_BY_OBJECT[objectTypeId || !isCustomObject(objectTypeId)];
};